import { schemaTranslations } from '@scalar/blocks/schema'
import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const pt = {
  common: {
    streamItem: 'Item do fluxo',
    description: 'Descrição',
    httpMethod: 'Método HTTP',
    path: 'Caminho',
    copyDefault: 'Copiar valor padrão',
    copyExample: 'Copiar valor de exemplo',
  },
  search: {
    label: 'Buscar',
    inputLabel: 'Digite o termo de busca',
    open: 'Abrir Busca',
    placeholder: 'Buscar...',
    clear: 'Limpar Busca',
    noResults: 'Nenhum resultado encontrado',
    keyboardShortcut: 'Atalho de Teclado:',
    command: 'Command',
    control: 'Control',
    results: 'Resultados da Busca de Referência',
    navigate: 'Navegar',
    select: 'Selecionar',
    instructions:
      'Pressione seta para cima / seta para baixo para navegar, enter para selecionar, digite para filtrar resultados',
    entryHeading: 'Título',
    entryOperation: 'Operação',
    entryTag: 'Tag',
    entryTagGroup: 'Grupo de Tags',
    entryChannel: 'Canal',
    entryMessage: 'Mensagem',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: 'Introdução',
    closeGroup: 'Fechar Grupo',
    closeMenu: 'Fechar Menu',
    openGroup: 'Abrir Grupo',
    openMenu: 'Abrir Menu',
    operations: 'Operações',
    endpoints: 'Endpoints de {name}',
    showAllEndpoints: 'Mostrar todos os endpoints de {name}',
    sidebarFor: 'Barra lateral de {name}',
    mainContent: 'Documentação da API para {name}',
    collapsed: 'Recolhido',
    webhooks: 'Webhooks',
    channels: 'Canais',
  },
  server: {
    label: 'Servidor',
    select: 'Selecione um servidor',
  },
  info: {
    termsOfService: 'Termos de Serviço',
  },
  asyncapi: {
    address: 'Endereço',
    unknownAddress: 'Desconhecido',
    applicationIdentifier: 'Identificador da aplicação',
    servers: 'Servidores',
    protocols: 'Protocolos',
  },
  clientLibraries: {
    heading: 'Bibliotecas Cliente',
    more: 'Mais',
    selectAll: 'Selecionar de todos os clientes',
    searchLabel: 'Pesquisar clientes',
    changeClient: 'Alterar a linguagem do exemplo de código',
  },
  operation: {
    codeSampleUnavailable: 'Nenhuma amostra de código disponível para este exemplo.',
    codeSample: 'Exemplo de código',
    body: 'Corpo',
    cookies: 'Cookies',
    headers: 'Cabeçalhos',
    pathParameters: 'Parâmetros de Caminho',
    queryParameters: 'Parâmetros de Consulta',
    requestBody: 'Corpo da Requisição',
    responses: 'Respostas',
    testRequest: 'Testar Requisição',
    webhook: 'Webhook',
    audience: 'Público',
    selectedContentType: 'Tipo de Conteúdo Selecionado',
    callbacks: 'Callbacks',
  },
  response: {
    xmlGenerationLimit:
      'O exemplo XML excede o limite de geração. Forneça um exemplo XML serializado para exibir o conteúdo completo.',
    xmlGenerationFailed: 'Não foi possível gerar um exemplo XML: {message}',
    exampleResponses: 'Exemplos de Respostas',
    noBody: 'Sem Corpo',
    showSchema: 'Mostrar Schema',
    status: 'Status',
  },
  schema: schemaTranslations['pt'].schema,
  download: {
    openapi: 'Baixar Documento OpenAPI',
    asyncapi: 'Baixar Documento AsyncAPI',
    asFormat: '{label} em {format}',
  },
  models: {
    label: 'Modelos',
  },
  actions: {
    copyAsMarkdown: 'Copiar como Markdown',
    copied: 'Copiado',
    copyMarkdownFailed: 'Não foi possível copiar o Markdown',

    copyLink: 'Copiar link',
    copyLinkTo: 'Copiar link para {name}',
    copyToClipboard: 'Copiar link para a área de transferência',
    copyEndpointUrl: 'Copiar URL do endpoint',
    showMore: 'Mostrar Mais',
  },
  agent: {
    askAi: 'Perguntar à IA',
    askAiAgent: 'Perguntar ao Agente de IA',
    close: 'Fechar Cliente',
  },
  mcp: {
    generate: 'Gerar MCP',
    connect: 'Conectar MCP',
  },
  sdk: {
    generate: 'Gerar SDK',
  },
  developerTools: {
    title: 'Ferramentas de Desenvolvedor',
    configure: 'Configurar',
    share: 'Compartilhar',
    deploy: 'Implantar',
    scalarConfiguration: 'Configuração do Scalar',
    theme: 'Tema',
    layout: 'Layout',
    layoutOptions: 'Opções de Layout',
    intro:
      'As ferramentas de desenvolvedor permitem personalizar a aparência e o comportamento da sua documentação. Você também pode compartilhar sua documentação usando o Scalar Registry.',
    disableToolbarBefore: 'Para desativar a barra de ferramentas, defina',
    disableToolbarAfter: 'na sua configuração.',
    localhostOnly: 'As ferramentas de desenvolvedor só aparecerão ao rodar em localhost.',
    layoutModern: 'Moderno',
    layoutClassic: 'Clássico',
    showSidebar: 'Mostrar Barra Lateral',
    defaultOpenFirstTag: 'Abrir Primeira Tag por Padrão',
    defaultOpenAllTags: 'Abrir Todas as Tags por Padrão',
    expandAll: 'Expandir Todos {label}',
    expandAllParameters: 'Expandir todos os parâmetros',
    expandAllSchemaProperties: 'Expandir todas as propriedades do esquema',
    hideModelNames: 'Ocultar nomes dos modelos',
    orderRequiredPropertiesFirst: 'Propriedades obrigatórias primeiro',
    orderSchemaPropertiesBy: 'Ordem das propriedades do esquema',
    alphabeticalOrder: 'Alfabética',
    documentOrder: 'Ordem do documento',
    expandAllResponses: 'Expandir Todas as Respostas',
    hideClientButton: 'Ocultar Botão do Cliente',
    hideDarkModeToggle: 'Ocultar Alternador de Modo Escuro',
    hideModels: 'Ocultar {label}',
    hideSearch: 'Ocultar Busca',
    showOperationId: 'Mostrar ID da Operação',
    hideTestRequestButton: 'Ocultar Botão de Testar Requisição',
    scalarDocs: 'Documentação do Scalar',
    deployDescription:
      'Implante sua documentação no Scalar, a plataforma de documentação moderna para sua API e tudo mais.',
    shareTitle: 'Compartilhe sua Referência de API',
    shareDescription:
      'Envie seu documento OpenAPI para compartilhar sua Referência de API com outras pessoas. Tão fácil quanto apertar um botão.',
    uploadDocument: 'Enviar Documento',
    temporaryLinkExpiration: 'Seu documento será excluído automaticamente após 7 dias.',
    deployOnScalar: 'Implantar no Scalar',
    deployFree: 'Implante sua documentação gratuitamente.',
    additionalFeaturesMightRequire: 'Recursos adicionais podem exigir',
    generate: 'Gerar',
    passwordProtection: 'Proteção por Senha',
    customDomains: 'Domínios Personalizados',
    freeFormContent: 'Conteúdo de formato livre',
    cdnInfrastructure: 'Infraestrutura de CDN',
    pullFromGitHub: 'Importar do GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Linting com Spectral',
    jsonSchemaHosting: 'Hospedagem de JSON Schema',
    askAi: 'Perguntar à IA',
    mcpServers: 'Servidores MCP',
    unableToExportDocument: 'Não foi possível exportar o documento ativo',
    unknownError: 'Ocorreu um erro desconhecido',
  },
  exploreScalar: {
    cta: 'Gerar SDKs e MCP',
    headline: 'Gere SDKs, MCPs e docs para a sua API instantaneamente',
    title: 'Tudo o que a sua API precisa, a partir de um único documento OpenAPI',
    generateTitle: 'SDKs e servidores MCP',
    generateDescription:
      'Bibliotecas cliente tipadas e um servidor MCP, gerados a partir deste documento e mantidos em sincronia.',
    platformTitle: 'Docs, portais para desenvolvedores e registro',
    platformDescription:
      'Publique esta referência com guias, hospede suas APIs em um registro e teste-as no cliente de API.',
    signUp: 'Experimente grátis',
    bookDemo: 'Agende uma demo com Marc, nosso CEO',
    getDemo: 'ou agende uma demo com Marc',
    messageMarc: 'Envie uma mensagem para Marc no X',
    dmMarc: 'ou só me manda uma DM no X!',
    close: 'Fechar',
    opensInNewTab: 'Abre em uma nova aba',
    popupBlocked: 'Seu navegador bloqueou a nova aba. Clique novamente no botão para abri-la.',
    back: 'Voltar',
    openBookingPage: 'Abrir a página de agendamento',
  },
  gettingStarted: {
    swaggerEditor: 'Editor Swagger',
    description:
      'Bem-vindo às Referências de API Scalar + Editor Swagger, uma ferramenta gratuita e de código aberto que transforma seu arquivo Swagger/OAS em belas referências de API.',
    showExample: 'Mostrar Exemplo',
    uploadFile: 'Enviar Arquivo',
    integrations: 'INTEGRAÇÕES',
    theming: 'TEMAS',
    features: 'Recursos',
    customize: 'Personalizar',
    customizeDescription: 'Traga sua tipografia e paletas de cores, ou use nossos temas!',
    testing: 'Testes',
    testingDescription: 'Um Cliente de API REST profundamente integrado (Também gratuito e de código aberto)',
    search: 'Busca',
    searchDescription: 'Busca totalmente integrada (usando fuse.js)',
    hosting: 'Hospedagem',
    hostingDescription: 'Hospedagem gratuita de subdomínio em https://apidocumentation.com',
    openApiSwagger: 'OpenAPI e Swagger',
    openApiSwaggerDescription: 'Suporte para OpenAPI 3.1, OpenAPI 3.0 e Swagger 2.0',
    codeSamples: 'Exemplos de Código',
    codeSamplesDescription: 'Exemplos de código para mostrar sua API nas linguagens mais populares',
  },
  footer: {
    poweredByScalar: 'Desenvolvido com Scalar',
  },
  authentication: {
    detailsRequired: 'Autenticação obrigatória',
    detailsOptional: 'Autenticação opcional',
    apiKey: 'Chave de API',
    mutualTLS: 'TLS mútuo',
    apiKeyCookie: 'Envie a chave de API no cookie “{name}”.',
    apiKeyHeader: 'Envie a chave de API no cabeçalho “{name}”.',
    apiKeyQuery: 'Envie a chave de API no parâmetro de consulta “{name}”.',
    title: 'Autenticação',
    accepts: 'Aceita',
    allOf: 'todos de:',
    authentication: 'autenticação',
    optional: 'Autenticação Opcional',
    oneOf: 'um de:',
    required: 'Autenticação Obrigatória',
    requires: 'Requer',
    scopes: 'Escopos OAuth',
  },
} satisfies ApiReferenceTranslations
